import { Suspense } from 'react';
import pages from '~react-pages';
import { useRoutes } from 'react-router-dom';
import { LoadingScreen } from './loading-screen';

import { usePendoMetadata, PendoMetadata } from '../hooks/usePendoMetadata';
import { usePendo } from '@flex/common/pendo';

export function App(): JSX.Element {
	const component = useRoutes(pages);

	const pendoMetadata = usePendoMetadata();

	usePendo<PendoMetadata | null>(
		pendoMetadata,
		import.meta.env.VITE_PENDO_API_KEY
	);

	return <Suspense fallback={<LoadingScreen />}>{component}</Suspense>;
}
